<template>

	<x-modal
		width="650"
		v-if="visible == true"
		@cancel="visible = false"
		@close="visible = false"
		@ok="invoiceRequested"
		:draggable="true"
		:resizable="true"
		:loading="loading"
		:okDisabled="selectedAdvices.length !== settlementAdvices.length || submitting"
		okText="Send Settlement Advice">

		<div slot="title" :class="`d-flex justify-content-between align-items-center`">
			Send Settlement Advice
		</div>

		<div class="container">
			<div
				class="row pt-0 amb-modal-body"
				style="max-height: 650px; -ms-overflow-y: auto; overflow-y: auto; overflow-x: hidden;"
			>
				<div class="col-12 mt-4 mb-3">
					<!-- email to dealer -->

					<application-input
						class="input-belt mb-2"
						v-model="subjects['DEALER']"
						v-if="$store.getters.initAppData.seller_type_id === 1"
					>Subject</application-input>

					<application-input
						class="input-belt mb-2"
						v-model="subjects['PRIVATE_DEALER']"
						v-else
					>Subject</application-input>

					<div
						class="d-flex align-items-center amb-toggle-row-modal mb-2"
						v-for="seller in sellers"
						:key="seller.id"
					>
						<div class="amb-table-check-container mr-2">
							<input
								class="table-checkbox"
								type="checkbox"
								:value="seller.email"
								v-model="requestMail"
							/>
							<span class="amb-table-checkmark"></span>
						</div>
						<p>{{ $store.getters.initAppData.seller_type_id == 1 ? `${seller.name}` : `${seller.full_name}` }} {{seller.email}}</p>
					</div>

					<div>
						<label>Send Settlement Advice Notification To Customer</label>
					</div>
					<application-input class="input-belt mb-2" v-model="subjects['CUSTOMER']">Subject</application-input>
					<div v-for="applicant in applicants" :key="'notification_'+applicant.id">
						<!--primary email-->
						<div class="d-flex align-items-center amb-toggle-row-modal mb-2">
							<div class="amb-table-check-container mr-2">
								<input
									class="table-checkbox"
									type="checkbox"
									:value="applicant.email"
									v-model="sendNotificationToApplicants"
								/>
								<span class="amb-table-checkmark"></span>
							</div>
							<p>{{ applicant.first_name}} {{ applicant.last_name }} ({{ applicant.email }})</p>
						</div>
						<!--secondary email if exist-->
						<div
							class="d-flex align-items-center amb-toggle-row-modal mb-2"
							v-if="applicant.email2"
						>
							<div class="amb-table-check-container mr-2">
								<input
									class="table-checkbox"
									type="checkbox"
									:value="applicant.email2"
									v-model="sendNotificationToApplicants"
								/>
								<span class="amb-table-checkmark"></span>
							</div>
							<p>{{ applicant.first_name}} {{ applicant.last_name }} - secondary - ({{ applicant.email2 }})</p>
						</div>
					</div>

					<div>
						<label>Settlement Advice</label>
						<div v-for="advice in settlementAdvices" :key="advice.value">
							<div class="d-flex align-items-center amb-toggle-row-modal mb-2">
								<div class="amb-table-check-container mr-2">
									<input
										class="table-checkbox"
										type="checkbox"
										:value="advice.value"
										v-model="selectedAdvices"
									/>
									<span class="amb-table-checkmark"></span>
								</div>
								<p>{{advice.label}}</p>
							</div>
						</div>
					</div>

					<add-attachments
						:selected-data.sync="selectedDocuments"
						:doc-documents.sync="docDocuments"
						:show-title="false"
						></add-attachments>

					<!--notes or comments-->
					<div class="input-belt">
						<label>Enter any notes or comments to be include as "broker notes" in email to the customer</label>
						<summernote :model.sync="requestNote"></summernote>
					</div>

				</div>
			</div>
		</div>

	</x-modal>

</template>

<script>
import { Message } from "element-ui";
import DefaultTemplate from "../application-steps/scripts/DefaultTemplate";
import AddAttachments from "../documents/AddAttachments.vue";
export default {
  props: {
    remittanceDate: String,
    lenderContractNumber: String,
    application: Object,
    applicants: Array,
    openModal: Boolean,
    headers: Object,
    docDocuments: Array,
    settlementDocuments: Array
  },
  components: {
    "add-attachments": AddAttachments
  },
  watch: {
    settlementDocuments() {
      this.selectedDocuments = [];
      this.settlementDocuments.forEach(doc => {
        this.selectedDocuments.push(`${doc.id}-${Number(doc.is_app_document)}`);
      });
    },
    openModal(newVal, oldVal) {
      this.visible = newVal;
			this.getSellers();
      if (newVal) {
        this.$bus.$emit('sellerModal:open');
      }
    },
    visible(newVal, oldVal) {
      if (!newVal) {
        this.selectedDocuments = [];
      } else {
        this.selectedDocuments = [];
        this.settlementDocuments.forEach(doc => {
          if (
            !this.selectedDocuments.includes(
              `${doc.id}-${Number(doc.is_app_document)}`
            )
          ) {
            this.selectedDocuments.push(
              `${doc.id}-${Number(doc.is_app_document)}`
            );
          }
        });
      }
      this.$emit("update:openModal", newVal);
    }
  },
  computed:{
      firstSubject(){
          if (this.$store.getters.initAppData.seller_type_id === 1){
              return this.subjects.DEALER;
          } else {
              return this.subjects.PRIVATE_DEALER;
          }
      },
      secondSubject(){
          return this.subjects.CUSTOMER;
      }
  },
  methods: {
    getSettlementRequirements() {
      axios
        .get(
          `/api/applications/${this.$store.getters.initAppData.id}/send-and-settle/requirements`,
          this.headers
        )
        .then(res => {
          let settlements = res.data;
          this.settlementAdvices = [];
          settlements.forEach(element => {
            this.settlementAdvices.push({
              label: element.question,
              value: element.id,
              required: element.required
            });
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTemplates() {
      axios.get("/api/settings/email_templates", this.headers).then(res => {
        res.data.forEach(temp => {
          this.templates.push(temp);
        });
      });
    },
    invoiceRequested() {
      this.submitting = true;
      this.loading = true;
      this.$store
        .dispatch("statusIndicators/changeStatus", {
          stage: "settled",
          value: 2,
          token: this.$store.getters.token,
          appId: this.$store.getters.initAppData.id,
          note: this.requestNote,
          sendNotificationToApplicants: this.sendNotificationToApplicants,
          emails: this.requestMail,
          subject: this.firstSubject,
          subject2: this.secondSubject,
          attachments: this.selectedDocuments,
          remittanceDate: this.remittanceDate,
          lenderContractNumber: this.lenderContractNumber
          // documents: this.settlementDocuments
        })
        .then(res => {
     		 	this.loading = false;
          this.visible = false;
          Message({
            message: "Settlement Advice Sent",
            type: "success"
          });
        })
        .catch(err => {
					this.loading = false;
          Message({
            message: "Settlement Advice Cannot be Sent",
            type: "error"
          });
        })
        .finally(() => this.submitting = false);
    },
    getSellers() {
      axios
        .get(
          `/api/applications/${this.$store.getters.initAppData.id}/send-and-settle/sellers`,
          this.headers
        )
        .then(res => {
          this.sellers = res.data.filter(seller => seller != null);
        });
    },
    async getDealerTemplate() {
      try {
        let def = new DefaultTemplate(14, this.$store.getters.token, "dealer");
        def = await def.handle();
        if (def) this.subjects["DEALER"] = def.subject;
      } catch (err) {
        console.error(err);
      }
    },
    async getCustomerTemplate() {
      try {
        let def = new DefaultTemplate(
          14,
          this.$store.getters.token,
          "notification-customer"
        );
        def = await def.handle();
        if (def) this.subjects["CUSTOMER"] = def.subject;
      } catch (err) {
        console.error(err);
      }
    },
    async getPrivateSellerTemplate() {
      try {
        let def = new DefaultTemplate(
          14,
          this.$store.getters.token,
          "private dealer"
        );
        def = await def.handle();
        if (def) this.subjects["PRIVATE_DEALER"] = def.subject;
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getSellers();
    this.getSettlementRequirements();

    this.getCustomerTemplate();
    this.getPrivateSellerTemplate();

    this.getDealerTemplate();
  },
  data() {
    return {
      sellers: [],
      subjects: {
        DEALER: null,
        CUSTOMER: null,
        PRIVATE_DEALER: null
      },
      templates: [],
      settlementAdvices: [],
      selectedAdvices: [],
      selectedTemplate: null,
      requestMail: [],
      sendNotificationToApplicants: [],
      requestNote: "",
      selectedDocuments: [],

      visible: false,
      submitting: false,
			loading: false
    };
  }
};
</script>
